import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fuse from 'fuse.js';
import { SimpleList, List, SearchField, Dropdown } from '../../components';
import {
  articlesGroupByMonthYear,
  fullDateFormat,
  fullDateFormat2,
  fullDateFormat3,
  filterByYear
} from '../../utils';

class SearchArticles extends Component {
  state = {
    search: '',
    searchArticles: []
  };

  updateSearch = event => {
    this.setState({ search: event.target.value }, this.filterArticlesWithSearch);
  };

  filterArticlesWithSearch() {
    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      distance: 1000,
      maxPatternLength: 32,
      minMatchCharLength: 1,
      keys: [
        {
          name: 'title',
          weight: 0.5
        },
        {
          name: 'description',
          weight: 0.2
        },
        {
          name: 'fullDateFormat1',
          weight: 0.1
        },
        {
          name: 'fullDateFormat2',
          weight: 0.1
        },
        {
          name: 'fullDateFormat3',
          weight: 0.1
        }
      ]
    };

    const articles = this.props.items.map(item =>
      Object.assign(
        {
          fullDateFormat1: fullDateFormat(item.fullDate),
          fullDateFormat2: fullDateFormat2(item.fullDate),
          fullDateFormat3: fullDateFormat3(item.fullDate)
        },
        item
      )
    );

    const fuse = new Fuse(articles, options);

    if (this.state.search.length) {
      const fuseSearch = fuse.search(this.state.search);
      this.setState({ searchArticles: fuseSearch });
    } else {
      this.setState({ searchArticles: this.props.items });
    }
  }

  filterArticlesByYear = event => {
    const year = event.target.value;
    this.setState({ search: ' ', searchArticles: filterByYear(this.props.items, year) });
  };

  render() {
    const { backUrl, title, items } = this.props;
    const { search, searchArticles } = this.state;
    return (
      <div className="articles-list">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <span className="articles-list-back">
                <a href={backUrl}>
                  <i className="icon icon-budicon-463" aria-hidden="true" /> Back
                </a>
              </span>
            </div>
            <div className="col-sm-12 col-md-4">
              <h1 className="articles-list-title">{title}</h1>
            </div>
            <div className="col-sm-12 col-md-8">
              <div className="search-filter-bar">
                <SearchField
                  type="text"
                  id="search-input"
                  placeholder="Search"
                  value={search}
                  onChange={this.updateSearch}
                />
                <Dropdown
                  onChange={this.filterArticlesByYear}
                  title="Browse by Year"
                  values={['2018', '2017', '2016', '2015', '2014']}
                />
              </div>
            </div>
            {search.length ? (
              <SimpleList items={searchArticles} />
            ) : (
              <List items={articlesGroupByMonthYear(items)} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

SearchArticles.propTypes = {
  backUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string,
      title: PropTypes.string,
      date: PropTypes.string,
      description: PropTypes.string,
      thumbnail: PropTypes.string,
      fullDate: PropTypes.string
    })
  )
};

export default SearchArticles;



// WEBPACK FOOTER //
// ./src/pages/press/components/SearchArticles/SearchArticles.js